export const VIRTUALIZED_TABLE_HEADER_COLUMN_RESIZE_HANDLE =
    'VirtualizedTableHeaderColumnResizeHandle';
